module.exports = __webpack_public_path__ + "static/media/plus.853bec64.svg";